var map = {
	"./attraction-1.jpg": "./frontend/images/attraction-1.jpg",
	"./attraction-10.jpg": "./frontend/images/attraction-10.jpg",
	"./attraction-11.jpg": "./frontend/images/attraction-11.jpg",
	"./attraction-12.jpg": "./frontend/images/attraction-12.jpg",
	"./attraction-13.jpg": "./frontend/images/attraction-13.jpg",
	"./attraction-14.jpg": "./frontend/images/attraction-14.jpg",
	"./attraction-15.jpg": "./frontend/images/attraction-15.jpg",
	"./attraction-16.jpg": "./frontend/images/attraction-16.jpg",
	"./attraction-17.jpg": "./frontend/images/attraction-17.jpg",
	"./attraction-18.jpg": "./frontend/images/attraction-18.jpg",
	"./attraction-19.jpg": "./frontend/images/attraction-19.jpg",
	"./attraction-2.jpg": "./frontend/images/attraction-2.jpg",
	"./attraction-20.jpg": "./frontend/images/attraction-20.jpg",
	"./attraction-21.jpg": "./frontend/images/attraction-21.jpg",
	"./attraction-22.jpg": "./frontend/images/attraction-22.jpg",
	"./attraction-23.jpg": "./frontend/images/attraction-23.jpg",
	"./attraction-24.jpg": "./frontend/images/attraction-24.jpg",
	"./attraction-25.jpg": "./frontend/images/attraction-25.jpg",
	"./attraction-26.jpg": "./frontend/images/attraction-26.jpg",
	"./attraction-27.jpg": "./frontend/images/attraction-27.jpg",
	"./attraction-28.jpg": "./frontend/images/attraction-28.jpg",
	"./attraction-29.jpg": "./frontend/images/attraction-29.jpg",
	"./attraction-3.jpg": "./frontend/images/attraction-3.jpg",
	"./attraction-30.jpg": "./frontend/images/attraction-30.jpg",
	"./attraction-31.jpg": "./frontend/images/attraction-31.jpg",
	"./attraction-32.jpg": "./frontend/images/attraction-32.jpg",
	"./attraction-33.jpg": "./frontend/images/attraction-33.jpg",
	"./attraction-34.jpg": "./frontend/images/attraction-34.jpg",
	"./attraction-35.jpg": "./frontend/images/attraction-35.jpg",
	"./attraction-36.jpg": "./frontend/images/attraction-36.jpg",
	"./attraction-37.jpg": "./frontend/images/attraction-37.jpg",
	"./attraction-38.jpg": "./frontend/images/attraction-38.jpg",
	"./attraction-39.jpg": "./frontend/images/attraction-39.jpg",
	"./attraction-4.jpg": "./frontend/images/attraction-4.jpg",
	"./attraction-40.jpg": "./frontend/images/attraction-40.jpg",
	"./attraction-5.jpg": "./frontend/images/attraction-5.jpg",
	"./attraction-6.jpg": "./frontend/images/attraction-6.jpg",
	"./attraction-7.jpg": "./frontend/images/attraction-7.jpg",
	"./attraction-8.jpg": "./frontend/images/attraction-8.jpg",
	"./attraction-9.jpg": "./frontend/images/attraction-9.jpg",
	"./burnaby-logo-fallback.png": "./frontend/images/burnaby-logo-fallback.png",
	"./burnaby-logo.svg": "./frontend/images/burnaby-logo.svg",
	"./bvm-logo-fallback.png": "./frontend/images/bvm-logo-fallback.png",
	"./bvm-logo.svg": "./frontend/images/bvm-logo.svg",
	"./header-default.jpg": "./frontend/images/header-default.jpg",
	"./interactive-map.jpg": "./frontend/images/interactive-map.jpg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./frontend/images sync recursive ^\\.\\/.*$";